// 用户相关的 action types
// 设置用户信息
export const SET_USER = 'SET_USER';
// 用户登出
export const LOGOUT = 'LOGOUT';
// 登录失败的错误信息
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
// 清除错误信息
export const CLEAR_ERROR = 'CLEAR_ERROR';
// 更新用户的舌诊次数
export const UPDATE_USER_DIAGNOSES = 'UPDATE_USER_DIAGNOSES';
// 绑定微信
export const BIND_WECHAT = 'BIND_WECHAT';
// 解绑微信
export const UNBIND_WECHAT = 'UNBIND_WECHAT';
// 微信绑定错误信息
export const WECHAT_BINDING_ERROR = 'WECHAT_BINDING_ERROR';
// 设置医生列表
export const SET_DOCTORS = 'SET_DOCTORS';
// 更新医生列表
export const UPDATE_DOCTORS = 'UPDATE_DOCTORS';
// 取消授权医生
export const ANTI_AUDIT_DOCTOR = 'ANTI_AUDIT_DOCTOR';
// 设置URL参数中的手机号
export const SET_PHONE = 'SET_PHONE';
